import I from '../types.ts';

const getScrollParent: I['getScrollParent'] = function () {
    return this.parent.current?.querySelector('.v2notificationBar__pageScroll') as HTMLElement;
};

export default getScrollParent;
